<template>
    <div v-if="user">
        <div class="panel panel-success">

            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU VOLTAR
            </div>
            <div class="panel-body" v-if="user.level < 5" >
                <p>
                    <a :href="url" v-if="url" class="btn btn-default btn-block">VOLTAR</a>
                    <a @click="back()" v-else class="btn btn-default btn-block">VOLTAR</a>
                </p>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            default: null
        }
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    methods: {
        back() {
            window.history.back();
        }
    }
};
</script>
